export default {"src":"/_next/static/media/chevron-right.fea4cc09.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};